import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, Box } from 'rebass/styled-components';
import { layout, space, fontSize } from 'styled-system';
import theme from 'styled-theming';
import { ReactComponent as Watson } from '../assets/watson.svg';
import { ReactComponent as GoogleDialogFlow } from '../assets/dialogflow.svg';
import { ReactComponent as LivePerson } from '../assets/liveperson.svg';

const ICON_SIZE = 20;
const RADIO_SIZE = 14;

const textColor = theme('mode', {
  light: (props) => props.theme.colors.black,
  dark: (props) => props.theme.colors.midLightGrey,
});

const iconColor = theme('mode', {
  light: (props) => props.theme.colors.black,
  dark: (props) => props.theme.colors.midLightGrey,
});

const WatsonLogo = styled(Watson)`
  ${space}
  color: ${iconColor};
`;
const GoogleDialogFlowLogo = styled(GoogleDialogFlow)`
  ${space}
  color: ${iconColor};
`;
const LivePersonLogo = styled(LivePerson)`
  ${space}
  color: ${iconColor};
`;

const Input = styled.input`
  ${space}
  ${fontSize}
  ${layout}
  cursor: pointer;
  font-family: inherit;
`;

const Label = styled.label`
  ${fontSize}
  display: flex;
  align-items: center;
  font-weight: 300;
  cursor: pointer;
  user-select: none;
  color: ${textColor};
`;

const getIcon = (name) => {
  switch (name) {
    case 'Watson':
      return <WatsonLogo width={ICON_SIZE} height={ICON_SIZE} mr={2} />;
    case 'Google DialogFlow':
      return <GoogleDialogFlowLogo width={ICON_SIZE} height={ICON_SIZE} mr={2} />;
    case 'Conversation Builder':
      return <LivePersonLogo width={ICON_SIZE} height={ICON_SIZE} mr={2} />;
    default:
      return null;
  }
};

function BotType(props) {
  const {
    type, activeBotType, handleChange, ...otherProps
  } = props;

  const name = type && type.name;
  const lowercaseType = type && type.type && type.type.toLowerCase();
  return (
    <Flex {...otherProps}>
      <Label
        fontSize={2}
        onClick={() => handleChange(name)}
        data-testid={`radio-input-${lowercaseType}`}
      >
        <Input
          type="radio"
          name="botType"
          value={name}
          id={`${name}Radio`}
          p={0}
          m={0}
          mr={2}
          width={RADIO_SIZE}
          height={RADIO_SIZE}
          fontSize={0}
          checked={activeBotType && activeBotType.name === name}
          readOnly
        />
        {getIcon(name)}
        <Box fontSize={1} data-testid="botype-name">
          {name}
        </Box>
      </Label>
    </Flex>
  );
}

BotType.defaultProps = {
  activeBotType: undefined,
  type: undefined,
};

BotType.propTypes = {
  handleChange: PropTypes.func.isRequired,
  activeBotType: PropTypes.shape({
    name: PropTypes.string.isRequired,
    inputType: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
  type: PropTypes.shape({
    name: PropTypes.string.isRequired,
    inputType: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
};

export default BotType;
